import {FC} from 'react'

import { toAbsoluteUrl} from '../../../../_metronic/helpers'

const Error500: FC = () => {
  return (
    <>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>System Error</h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        Something went wrong! <br /> Please try again later.
      </div>
      <div className="mb-11">
          <img src={toAbsoluteUrl('/media/auth/Error.png')} className="mw-100 mh-300px theme-light-show" alt="Internal server Error"/>
      </div>
    </>
  )
}

export {Error500}
